import { MetricLengthUnit, MetricWeightUnit } from '@/models/interfaces/metric'


export default class Unit<U extends MetricLengthUnit | MetricWeightUnit> {
  private _value: number
  private _unit: string
  private _validator: (unit: string | string) => boolean

  constructor (value: number | string | Unit<U>, unit?: string, validator?: (unit: string) => boolean) {
    const parsed = Unit.parse(value instanceof Unit ? value.value : value, unit as any, validator)

    if (!parsed) throw Error(`Failed to parse value "${value}" as unit`)

    this._value = parsed.value
    this._unit = parsed.unit
    this._validator = validator || Unit.validateUnit
  }

  get value () {
    return this._value
  }

  set value (value: number) {
    // if (isNaN(parseInt(value as any))) return
    // this._value = parseFloat(value as any)
    this._value = value
  }

  get unit () {
    return this._unit
  }


  set unit (unit) {
    if (!this._validator(unit)) return
    this._unit = unit
  }

  get toString () {
    return `${this._value}${this._unit}`
  }

  /**
   * @param valueString string to parse, if a number is supplied, will return the number unchanged as the value paired with the default unit
   * @param defaultUnit the default fallback unit. if the extracted unit is not a valid constituent of MetricWeightUnit, this value will also be used
   * @returns { value: number, unit: U }
   */
  static parse <U extends MetricLengthUnit | MetricWeightUnit | string> (valueString: string | number, defaultUnit: U, validator?: (unit: string) => boolean): { value: number, unit: U } | null  {
    if (typeof valueString === 'number') return { value: valueString, unit: defaultUnit }

    const regex = /^(0|[1-9]\d*|[0-9]+([.,]\d+)?)\s*([a-zA-Z]+)?$/
    const match = valueString.match(regex)

    if (match) {
      const numberPart = match[1]
      const unitPart = match[3]

      return {
        value: isNaN(parseInt(numberPart)) ? 0 : parseFloat(numberPart.replace(',', '.')),
        unit: (((validator || Unit.validateUnit)(unitPart)) ? unitPart as U : defaultUnit) || defaultUnit
      }
    }

    return null // Return null if the string doesn't match the pattern

  }

  static validateUnit (unit: MetricLengthUnit | MetricWeightUnit | string) {
    // TODO: include all possible units
    return Object.values(MetricWeightUnit).includes(unit as any)
  }
}
